import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, ValueObject } from '@digibricks/core';
export var AudioPlayStats = /*#__PURE__*/function (_ValueObject) {
  _inherits(AudioPlayStats, _ValueObject);

  var _super = _createSuper(AudioPlayStats);

  function AudioPlayStats() {
    _classCallCheck(this, AudioPlayStats);

    return _super.apply(this, arguments);
  }

  _createClass(AudioPlayStats, [{
    key: "audioFileId",
    get: function get() {
      return this.props.audioFileId;
    }
  }, {
    key: "hasPlayed",
    get: function get() {
      return this.props.hasPlayed;
    }
  }, {
    key: "numberOfReplays",
    get: function get() {
      return this.props.numberOfReplays;
    }
  }, {
    key: "getConsumedAudioPlayEventsCount",
    value: function getConsumedAudioPlayEventsCount(stat) {
      var _stat$numberOfReplays;

      if (!stat) return 0;
      return ((_stat$numberOfReplays = stat.numberOfReplays) !== null && _stat$numberOfReplays !== void 0 ? _stat$numberOfReplays : 0) + 1;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new AudioPlayStats(props));
    }
  }]);

  return AudioPlayStats;
}(ValueObject);